module.exports = __webpack_public_path__ + "static/media/404.0ab9728e.webm";